import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface AutocompleteSuggestion {
  suggestion: string;
  source: string;
  frequency: number;
}

export function useSearchAutocomplete(query: string, debounceMs: number = 150) {
  const [suggestions, setSuggestions] = useState<AutocompleteSuggestion[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed.length < 1) {
      setSuggestions([]);
      return;
    }

    setIsLoading(true);
    const timer = setTimeout(async () => {
      try {
        const { data, error } = await supabase.rpc('search_autocomplete', {
          prefix: trimmed,
          max_results: 6,
        });

        if (!error && data) {
          setSuggestions(
            (data as any[]).map(d => ({
              suggestion: d.suggestion,
              source: d.source,
              frequency: Number(d.frequency),
            }))
          );
        } else {
          setSuggestions([]);
        }
      } catch {
        setSuggestions([]);
      } finally {
        setIsLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [query, debounceMs]);

  return { suggestions, isLoading };
}
